// DS4.8 - Slider Variant
import React from 'react';
import c from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Slider, {
  type SliderProps,
  DefaultPreviousButton,
  DefaultNextButton,
} from '@wix/da-ds/pkg/Slider';
import s from './FacetListRow.scss';

interface Props extends Pick<SliderProps, 'scrollToIndex' | 'scrollBy'> {
  facets: React.ReactElement[];
  className?: string;
  contentClassName?: string;
}

/**
 *
 * Included in da-shared-react because it relies on Slider
 */
const FacetListRow: React.FC<Props> = ({ facets, className, contentClassName, ...sliderProps }) => {
  return (
    <Slider
      {...sliderProps}
      className={c(s['root'], className)}
      contentClassName={c(s['content'], contentClassName)}
      renderPrevButton={({ onClick, className: prevButtonClassName }) => (
        <DefaultPreviousButton
          onClick={onClick}
          className={c(prevButtonClassName, s['prev-button'])}
          arrowSize={IconSize.SMALLER}
        />
      )}
      renderNextButton={({ onClick, className: nextButtonClassName }) => (
        <DefaultNextButton
          onClick={onClick}
          className={c(nextButtonClassName, s['next-button'])}
          arrowSize={IconSize.SMALLER}
        />
      )}
      permArrows
      noSpacing
    >
      {facets}
    </Slider>
  );
};

FacetListRow.displayName = 'FacetListRow';

export default FacetListRow;
